<template>
  <svg
    class="vue-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 29.501 19.501"
  >
    <g id="Logo-paypal" transform="translate(0 0.5)">
      <g id="Logo_Paypal_Text" data-name="Logo / Paypal / Text">
        <path
          id="pal"
          d="M21.637,5.569a1.9,1.9,0,0,1-.4-1.589A2.449,2.449,0,0,1,23.647,1.9a1.576,1.576,0,0,1,1.275.433L25,2.439l.048-.289A.185.185,0,0,1,25.231,2h1.08a.182.182,0,0,1,.186.208l-.584,3.54A.311.311,0,0,1,25.6,6H24.63a.183.183,0,0,1-.185-.209l.048-.287A2.1,2.1,0,0,1,23,6.095,1.727,1.727,0,0,1,21.637,5.569Zm1.055-1.577a.852.852,0,0,0,.169.726A.932.932,0,0,0,23.586,5a1.19,1.19,0,0,0,1.22-.987.86.86,0,0,0-.184-.731A.928.928,0,0,0,23.9,3,1.194,1.194,0,0,0,22.692,3.992ZM26.844,6a.183.183,0,0,1-.186-.208L27.584.152A.186.186,0,0,1,27.77,0h1.042A.183.183,0,0,1,29,.208l-.913,5.538a.309.309,0,0,1-.31.254ZM16.277,6a.183.183,0,0,1-.186-.208L17,.253A.308.308,0,0,1,17.313,0h2.255a2.147,2.147,0,0,1,1.644.552A1.61,1.61,0,0,1,21.5,1.946,2.29,2.29,0,0,1,18.933,4H18.22a.308.308,0,0,0-.31.253l-.259,1.57A.217.217,0,0,1,17.435,6ZM18.388,1.35,18.149,2.8h.341c.6,0,1.216,0,1.339-.776a.7.7,0,0,0-.11-.6c-.2-.221-.582-.221-.989-.221h-.157A.185.185,0,0,0,18.388,1.35Z"
          transform="translate(0 11.602)"
          fill="#458ec3"
          stroke="rgba(0,0,0,0)"
          stroke-width="1"
        />
        <path
          id="pay"
          d="M8093.175-16303.6a.18.18,0,0,1-.151-.286l1.125-1.519-1.2-3.361a.18.18,0,0,1,.176-.237h1.068a.31.31,0,0,1,.3.213l.634,2.03,1.5-2.112a.318.318,0,0,1,.258-.131h1.089a.179.179,0,0,1,.151.283l-3.61,4.989a.311.311,0,0,1-.258.131Zm-5.625-1.829a1.89,1.89,0,0,1-.405-1.589,2.449,2.449,0,0,1,2.411-2.079,1.578,1.578,0,0,1,1.277.43l.074.106.049-.291a.188.188,0,0,1,.184-.151h1.081a.184.184,0,0,1,.188.209l-.585,3.541a.309.309,0,0,1-.311.254h-.97a.188.188,0,0,1-.188-.209l.049-.286a2.1,2.1,0,0,1-1.494.589A1.732,1.732,0,0,1,8087.55-16305.43Zm1.052-1.576a.854.854,0,0,0,.172.725.921.921,0,0,0,.724.278,1.2,1.2,0,0,0,1.22-.986.882.882,0,0,0-.185-.733.932.932,0,0,0-.72-.282A1.2,1.2,0,0,0,8088.6-16307.006Zm-6.415,2.006a.181.181,0,0,1-.184-.209l.913-5.538a.306.306,0,0,1,.307-.254h2.256a2.146,2.146,0,0,1,1.646.553,1.61,1.61,0,0,1,.287,1.4,2.289,2.289,0,0,1-2.567,2.051h-.712a.31.31,0,0,0-.312.254l-.246,1.494a.309.309,0,0,1-.311.254Zm2.112-4.65-.241,1.449h.344c.6,0,1.216,0,1.338-.778a.7.7,0,0,0-.11-.6c-.2-.221-.582-.221-.991-.221h-.155A.185.185,0,0,0,8084.3-16309.65Z"
          transform="translate(-8082 16322.602)"
          fill="#283467"
        />
      </g>
      <g
        id="Logo_Paypal_Monogram"
        data-name="Logo / Paypal / Monogram"
        transform="translate(10.283)"
      >
        <path
          id="Logo_Paypal_Light"
          data-name="Logo / Paypal / Light"
          d="M7.182.719A3.16,3.16,0,0,0,4.823,0H1.729a.437.437,0,0,0-.437.358L0,8.178a.258.258,0,0,0,.262.294h1.91l-.132.8a.226.226,0,0,0,.229.257h1.61a.382.382,0,0,0,.382-.313l.016-.078.3-1.841.02-.1a.382.382,0,0,1,.382-.313h.241A2.816,2.816,0,0,0,8.365,4.522a1.942,1.942,0,0,0-.322-1.775A1.533,1.533,0,0,0,7.6,2.421a1.835,1.835,0,0,0-.42-1.7"
          transform="translate(0)"
          fill="#458ec3"
        />
        <path
          id="Logo_Paypal_Mild"
          data-name="Logo / Paypal / Mild"
          d="M3.075,5.293h.908c1.783,0,3.179-.693,3.586-2.7.012-.059.022-.117.032-.173a1.835,1.835,0,0,0-.42-1.7A3.16,3.16,0,0,0,4.822,0H1.728a.437.437,0,0,0-.437.358L0,8.178a.258.258,0,0,0,.262.294h1.91l.48-2.913-.015.091a.436.436,0,0,1,.436-.358"
          transform="translate(0.001)"
          fill="#1d1a3e"
        />
        <path
          id="Logo_Paypal_Dark"
          data-name="Logo / Paypal / Dark"
          d="M3.171,2.431a.373.373,0,0,1,.215-.277.4.4,0,0,1,.167-.036H5.978a5.27,5.27,0,0,1,.8.056q.1.016.2.037t.193.047l.092.027a2.233,2.233,0,0,1,.335.136,1.835,1.835,0,0,0-.42-1.7A3.16,3.16,0,0,0,4.823,0H1.729a.437.437,0,0,0-.437.358L0,8.178a.258.258,0,0,0,.262.294h1.91l.48-2.913Z"
          transform="translate(0)"
          fill="#283467"
          stroke="rgba(0,0,0,0)"
          stroke-width="1"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconLogoPaypal',
};
</script>
